// extracted by mini-css-extract-plugin
var _1 = "LoginFormBodyActions-modulebutton__vHa5j";
var _2 = "LoginFormBodyActions-moduleloginAsEmployeeButton__IZWm_ LoginFormBodyActions-modulebutton__vHa5j";
var _3 = "LoginFormBodyActions-moduleresendCodeButton__Xt_Gh LoginFormBodyActions-modulebutton__vHa5j";
var _4 = "LoginFormBodyActions-modulesubmitButton__EKKfQ LoginFormBodyActions-modulebutton__vHa5j";
export { _1 as "button", _2 as "loginAsEmployeeButton", _3 as "resendCodeButton", _4 as "submitButton" }
